import { t } from 'i18next';

import * as apiArchive from 'api/ingredient/DeleteIngredientIdV1';
import * as apiRestore from 'api/ingredient/PostIngredientRestoreV1';
import { Characteristic } from 'enums/characteristic';
import * as Co2Label from 'types/Co2/Co2Label';
import * as Icon from 'types/Icon/Icon';
import * as IconList from 'types/Icon/IconList';
import * as AllergenList from 'types/Ingredient/Search/AllergenList';
import * as IngredientCategoryList from 'types/Ingredient/Search/IngredientCategoryList';
import * as NutriScore from 'types/Ingredient/Search/NutriScore';
import * as SeasonList from 'types/Ingredient/Search/SeasonList';
import * as TagList from 'types/Ingredient/Search/TagList';
import * as Image from 'types/Media/Image';

export type Type = {
	allergens: AllergenList.Type;
	calories: number | null;
	carbonDioxideLabel: Co2Label.Type | null;
	carbonDioxideValue: number | null;
	categories: IngredientCategoryList.Type;
	characteristic: Characteristic;
	countOfRecipes: number;
	density: number | null;
	hasNutriScore: boolean;
	id: string;
	image: Image.Type | null;
	lastEditedDateUtc: string;
	lastEditor: string | null;
	nameSingularTranslation: string;
	nutriScore: NutriScore.Type;
	price: number | null;
	seasons: SeasonList.Type;
	tags: TagList.Type;
};

export function create(): Type {
	return {
		allergens: AllergenList.create(),
		calories: null,
		carbonDioxideLabel: null,
		carbonDioxideValue: null,
		categories: IngredientCategoryList.create(),
		characteristic: Characteristic.SolidNonQuantifiable,
		countOfRecipes: 0,
		density: null,
		hasNutriScore: false,
		id: '',
		image: null,
		lastEditedDateUtc: '',
		lastEditor: null,
		nameSingularTranslation: '',
		nutriScore: NutriScore.create(),
		price: null,
		seasons: SeasonList.create(),
		tags: TagList.create(),
	};
}

export function getIcons(obj: Type, allergensUserSet: Set<string>): IconList.Type {
	const output: (Icon.Type | null)[] = [];
	output.push(...TagList.mapToIcons(obj.tags));
	output.push(...AllergenList.mapToIcons(obj.allergens, allergensUserSet));
	return output.filter((x) => x?.iconSvgUrl).map((x) => x as Icon.Type);
}

export function getAuthor(obj: Type): string {
	if (obj.lastEditor) return obj.lastEditor;
	return t('_general:UNKNOWN_AUTHOR');
}

export async function callApiArchive(id: string): Promise<void> {
	await apiArchive.callApi(id);
}

export async function callApiRestore(id: string): Promise<void> {
	await apiRestore.callApi(id);
}
